<template>
  <div class="rn-contact-area rn-section-gap" style="padding: 120px 0;">
    <div class="contact-form--1">
      <v-container>
        <v-row align="start" class="row--35">
          <v-col lg="12" md="12" sm="12" cols="12" order="2" order-md="1">
            <div class="section-title text-left mb--50 mb_sm--30 mb_md--30">
              <h2 class="heading-title">Contacto RRH:</h2>
              <p class="description">
                Dejanos tu C.V. en nuestra base de datos para cuando surja una
                vacante y nos pondremos en contacto.
              </p>
            </div>
            <div class="form-wrapper">
              <form @submit.prevent>
                <div
                  v-if="submitted && !$v.name.required"
                  class="invalid-feedback"
                >
                  El nombre es requerido.
                </div>
                <div
                  v-if="submitted && !$v.name.minLength"
                  class="invalid-feedback"
                >
                  El nombre debe contenter al menos 3 letras.
                </div>

                <label>
                  <input
                    type="text"
                    v-model="name"
                    placeholder="Nombre *"
                    :class="{
                      'is-invalid': submitted && $v.name.$error
                    }"
                  />
                </label>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">El email es requerido.</span>
                  <span v-if="!$v.email.email"
                    >Por favor ingresa un email válido.</span
                  >
                </div>
                <label>
                  <input
                    type="text"
                    v-model="email"
                    placeholder="Email *"
                    :class="{ 'is-invalid': submitted && $v.email.$error }"
                  />
                </label>
                <label>
                  <v-file-input
                    v-model="imageUploaded"
                    color="accent-3"
                    placeholder="Seleccionar CV *"
                    outlined
                    :show-size="1000"
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip
                        v-if="index < 2"
                        color="deep-purple accent-4"
                        dark
                        label
                        small
                      >
                        {{ text }}
                      </v-chip>

                      <span
                        v-else-if="index === 2"
                        class="overline grey--text text--darken-3 mx-2"
                      >
                        +{{ files.length - 2 }} File(s)
                      </span>
                    </template>
                  </v-file-input>
                </label>

                <!--              <label>
                  <input type="text" v-model="subject" placeholder="Asunto" />
                </label> -->
                <!--                 <label>
                  <textarea
                    v-model="message"
                    placeholder="¿Cómo podemos ayudarte?"
                  ></textarea>
                </label> -->
                <button
                  class="rn-button-style--2 btn_solid"
                  @click="submitForm"
                >
                  Enviar
                </button>
              </form>
            </div>
          </v-col>
          <!--           <v-col lg="6" md="6" sm="12" cols="12" order="1" order-md="2">
            <div class="thumbnail mb_md--40 mb_sm--40">
              <img
                src="../../assets/images/contacto/nosotros_home.jpg"
                alt="trydo"
              />
            </div>
          </v-col> -->
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import axios from '../../repositories/Repository'
import Swal from 'sweetalert2'
import { required, email, minLength } from 'vuelidate/lib/validators'
export default {
  data() {
    return {
      name: '',
      email: '',
      subject: '',
      message: '',
      submitted: false,
      imageUploaded: null,
      imageFile: ''
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(3)
    },
    email: {
      required,
      email
    }
    /*     message: {
      required
    } */
  },
  methods: {
    submitForm() {
      if (this.imageFile === '') {
        return
      }
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      let me = this
      /*      const formData = {
        name: this.name,
        email: this.email,
              subject: this.subject,
        message: this.message, 
        file: this.imageFile
      } */

      const formData = new FormData()

      formData.append('name', this.name)
      formData.append('email', this.email)
      formData.append('file', this.imageFile)

      axios
        .post('/contact/sendcv', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(response) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Email enviado',
            showConfirmButton: false,
            timer: 3000,
            width: '300px'
          })
          console.log(response)
          me.cleanForm()
        })
        .catch(function(error) {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Error',
            showConfirmButton: false,
            timer: 3000,
            width: '300px'
          })
          console.log(error)
        })
    },
    cleanForm() {
      this.submitted = false
      this.name = ''
      this.email = ''
      this.subject = ''
      this.message = ''
      this.imageFile = ''
      this.imageUploaded = null
    }
  },
  watch: {
    imageUploaded: function() {
      this.imageFile = event.target.files[0]
    }
  }
}
</script>

<style scoped>
.invalid-feedback {
  color: red;
}
.is-invalid {
  border-color: red;
}
</style>
